import Monthly, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/monthly/[friendlyUrl]';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Monthly;
